module.exports = __webpack_public_path__ + "img/telegram-logo.c0f55b96.png";